import React, { Component } from "react";
import { withRouter } from "react-router-dom";

export class Navbar extends Component {
  handleNav = () => {
    const { pathname } = window.location;
    if (pathname === "/loonslip" || pathname === "/tax-form") {
      this.props.history.push(pathname);
    } else {
      this.props.history.go(-1);
    }
  };

  render() {
    return (
      <div className="navbar">
        <div className="content">
          {/* <p>Tax.sr</p> */}
          {/* <img src={require('../../assets/images/tax-logo.png')} alt=""/> */}
          <p className="brand" onClick={this.handleNav}>
            Tax.sr
          </p>
        </div>
      </div>
    );
  }
}

export default withRouter(Navbar);
